import { ISearchAzureSavingsPlans, IAzureSavingsPlans } from './azureSavingsPlans.model';
import { IApiResponse, ISearchResponse } from '../../../common/models/common';
import request from '../../../utils/request';

class AzureSavingsPlansService {
  ENDPOINT = '/azure-savings-plans';

  public async searchAzureSavingsPlans(
    searchParams?: ISearchAzureSavingsPlans
  ): Promise<IApiResponse<ISearchResponse<IAzureSavingsPlans>>> {
    const url = `${this.ENDPOINT}/search`;
    return request({ url, method: 'POST', data: searchParams }).then((res) => {
      return res.data;
    });
  }

  public async getAzureSavingsPlansById(id: number): Promise<any> {
    const url = `${this.ENDPOINT}/${id}`;
    return request({ url, method: 'GET' }).then((res) => {
      return res.data;
    });
  }

  public async saveAzureSavingsPlans(data: IAzureSavingsPlans): Promise<any> {
    const { id, ...restData } = data;
    if (id > 0) {
      const url = `${this.ENDPOINT}/${id}`;
      return request({ url, method: 'PUT', data: restData }).then((res) => {
        return res.data;
      });
    } else {
      const url = `${this.ENDPOINT}`;
      return request({ url, method: 'POST', data: restData }).then((res) => {
        return res.data;
      });
    }
  }

  public async deleteAzureSavingsPlans(id: number): Promise<any> {
    const url = `${this.ENDPOINT}/${id}`;
    return request({ url, method: 'DELETE' }).then((res) => {
      return res.data;
    });
  }

  public async exportExcelFile(searchParams?: ISearchAzureSavingsPlans): Promise<any> {
    const url = `back-ground-processes/export-excel`;
    return request({
      url,
      method: 'POST',
      data: searchParams,
    }).then((res) => {
      return res;
    });
  }
}
export default new AzureSavingsPlansService();
